import React, { useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import LinkHandler from "./LinkHandler";
// import Timeline from "./Timeline"; // Импортируем компонент Timeline

export const Header = ({data}) => {
  const [isImageVisible, setImageVisible] = useState(false);
  React.useEffect(() => {
    setImageVisible(true);
  }, []);

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <TransitionGroup>
                  {data && (
                    <CSSTransition key="title" timeout={500} classNames="slide">
                      <h1>
                        {data.title}
                        <span></span>
                      </h1>
                    </CSSTransition>
                  )}
                  {data && (
                    <CSSTransition key="paragraph" timeout={500} classNames="slide">
                      <p>{data.paragraph}</p>
                    </CSSTransition>
                  )}
                </TransitionGroup>
                <LinkHandler href="/about-us" className="btn btn-blesk btn-lg page-scroll">
                  Подробнее
                </LinkHandler>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="home">
        <div className="container">
          <div className="row">
          {/* <div className="section-title"> */}
            <div className="col-xs-12 col-md-6 home-image">
              <CSSTransition
                in={isImageVisible}
                timeout={500}
                classNames="blur"
                unmountOnExit
              >
                <img
                  src="static/img/home.webp"
                  className="img-responsive"
                  alt="Профессиональная реставрация лифтовых кабин и металлических поверхностей в Санкт-Петербурге от компании Lift Blesk"
                />
              </CSSTransition>
            </div>
            <div className="col-xs-12 col-md-6 home-content">
              <div className="home-text">
                <h2>Реставрация лифтов в СПб</h2>
                <h3>Реставрация металлических поверхностей в Санкт-Петербурге (СПб): царапины, потёртости, химические ожоги</h3>
                <p>Мы более <strong>5 лет</strong> профессионально занимаемся <strong>восстановлением лифтовых кабин</strong>, порталов и других <strong>металлических изделий</strong> в Санкт-Петербурге.</p>
                <p>Наши специалисты <strong>устраняют</strong> глубокие <strong>царапины</strong>, <strong>потёртости</strong>, <strong>ржавчину</strong>, <strong>химические ожоги</strong>, и иные дефекты, возвращая металлам стильный и долговечный вид.</p>
                <p>Для работы мы используем современное оборудование и безопасные инструменты, гарантируя высокое качество <strong>реставрации нержавеющей стали</strong>, <strong>алюминия</strong>, <strong>меди</strong>, <strong>латуни</strong> и других металлов.</p>
              </div>
              <h3>Узнайте больше о нас</h3>
              <ul>
                <li>
                  <LinkHandler href="/about-us">О нас</LinkHandler> – Мы стремимся к идеалу в каждом проекте. Узнайте больше о нашей команде и ценностях.
                </li>
                <li>
                  <LinkHandler href="/metal-restoration-services">Услуги</LinkHandler> – Мы занимаемся реставрацией лифтов, устраняем повреждения и обновляем дизайн.
                </li>
                <li>
                  <LinkHandler href="/restoration-portfolio">Портфолио</LinkHandler> – Смотрите результаты реставрации в нашем портфолио.
                </li>
                <li>
                  <LinkHandler href="/customer-reviews">Отзывы</LinkHandler> – Убедитесь в качестве наших работ от наших реальных клиентов.
                </li>
                <li>
                  <LinkHandler href="/contacts">Контакты</LinkHandler> – Свяжитесь с нами, чтобы обсудить ваш проект.
                </li>
              </ul>

            </div>
          {/* </div> */}
          </div>

          {/* <Timeline /> */}

        </div>
      </div>

    </header>
  );
};